// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","MenuItem":"bgh_a bhn_vt bhn_ea bhn_a","MenuItem__Btn":"bgh_b bhn_z","MenuItem__subtitle":"bgh_c"};